<template>
    <div>

        <!-- Breadcrumb Section Start -->
        <section class="breadscrumb-section pt-0">
            <div class="container-fluid-lg">
                <div class="row">
                    <div class="col-12">
                        <div class="breadscrumb-contain">
                            <h2>{{ $t('Your Orders')}}</h2>
                            <nav>
                                <ol class="breadcrumb mb-0">
                                    <li class="breadcrumb-item active" aria-current="page">{{ $t('Your Orders')}}</li>
                                    <li class="breadcrumb-item">
                                        <router-link :to="{name: 'home', params: { lang : $i18n.locale }}" >
                                            <i class="fa-solid fa-house"></i>
                                        </router-link>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Breadcrumb Section End -->

        <!-- User Dashboard Section Start -->
        <section class="user-dashboard-section section-b-space">
            <div class="container-fluid-lg">
                <div class="dashboard-right-sidebar">

                    <div class="tab-pane fade show" id="pills-order" role="tabpanel"
                         aria-labelledby="pills-order-tab">
                        <div class="dashboard-order">
                            <div class="title">
                                <h2>{{ $t('Your Orders')}}</h2>
                                <span class="title-leaf title-leaf-gray">
                                    <svg class="icon-width bg-gray">
                                        <use xlink:href="/theme/assets/svg/leaf.svg#leaf"></use>
                                    </svg>
                                </span>
                            </div>

                            <div class="order-contain">

                                <div class="order-box dashboard-bg-box w-100" v-for="order in items?.data" :key="order.id" >
                                    <div class="order-container">
                                        <div class="order-icon">
                                            <i class="fa-solid fa-boxes-stacked"></i>
                                        </div>

                                        <div class="order-detail">

                                            <router-link
                                                :to="{name: 'orders.show', params: { id: order?.id , lang : $i18n.locale }}" >

                                                <h3 class="mb-1">
                                                    {{ $t('Order number') }} <span>{{ order?.id }}</span>
                                                </h3>

                                            </router-link>


                                            <h4 class="mb-1">
                                                {{ $t('Payment status') }}
                                                <span :class="{
                                                    'bg-success' : order.payment_status == 'paid'  ,
                                                }">{{ order?.payment_status_value }}</span>
                                            </h4>
                                            <h4>
                                                {{ $t('Total price') }} : {{ order?.total_price }} ر.س
                                            </h4>

                                            <h6 class="text-content">
                                                {{ $t('Date') }} : {{ order?.created_at }}
                                            </h6>
                                        </div>
                                    </div>

                                    <div class="product-order-detail mb-2" v-for="item in order?.items" :key="item.id">
                                        <template  v-if="item?.product !== null" >
                                            <router-link :to="{name: 'products.show', params: { id: item?.product?.id , lang : $i18n.locale  }}"
                                                         class="order-image">

                                                <img :src="item?.product?.image   ?? '/theme/assets/images/more/product-card.png'"
                                                     class="blur-up lazyload" :alt="item?.product?.name" width="60">
                                            </router-link>

                                            <div class="order-wrap">
                                                <router-link :to="{name: 'products.show', params: { id: item?.product?.id  , lang : $i18n.locale  }}">
                                                    <h3>{{ item?.product?.name }}</h3>
                                                </router-link>


                                                <span v-if="item?.selected_price !== null">
                                                    {{ item?.selected_price?.name }}
                                                </span>

    <!--                                            <p class="text-content">Cheddar dolcelatte gouda. Macaroni cheese-->
    <!--                                                cheese strings feta halloumi cottage cheese jarlsberg cheese-->
    <!--                                                triangles say cheese.</p>-->

                                                <ul class="product-size">
                                                    <li>
                                                        <div class="size-box">
                                                            <h6 class="text-content"> {{ $t('Price')}}: </h6>
                                                            <h5>{{ item?.price }} {{ $t('priceSymbol')}}</h5>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div class="size-box">
                                                            <h6 class="text-content">{{ $t('Quantity') }} : </h6>
                                                            <h5>{{ item?.quantity }}</h5>
                                                        </div>
                                                    </li>
                                                    <li class="text-content" v-for="attribute in item?.attributeValues">

                                                        <span class="text-title"> {{ attribute?.name }} :</span>

                                                        {{ attribute?.value }}
                                                    </li>

                                                </ul>

<!--                                                <div class="text-content"  v-for="attribute in item?.product?.attributes">-->
<!--                                                    <span class="text-title"> {{ attribute?.data?.name }} : </span>-->
<!--                                                    <template v-for="attribute_item in attribute.items" :key="attribute_item.id">-->
<!--                                                        <template v-if="attribute_item?.selected_attribute">-->
<!--                                                            <a-->
<!--                                                                href="javascript:void(0)"-->
<!--                                                                :class="{ active : attribute_item?.selected_attribute }"-->
<!--                                                            >-->
<!--                                                                {{ attribute_item.value }}-->
<!--                                                            </a>-->
<!--                                                        </template>-->
<!--                                                    </template>-->
<!--                                                </div>-->
                                            </div>
                                        </template>
                                        <div class="alert alert-info" v-else>
                                            منتج محذوف.
                                        </div>
                                    </div>

<!--                                    <div class="d-flex ">-->
<!--                                        <a v-if="order?.can_pay === true"-->
<!--                                                class="btn btn-animation btn-sm mend-auto"-->
<!--                                        :href="'/payment?id=' + order?.id ">-->
<!--                                            {{ $t('Pay now') }} <i class="fa-solid fa-arrow-left icon"></i>-->
<!--                                        </a>-->
<!--                                    </div>-->


                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- User Dashboard Section End -->
    </div>
</template>

<script>

import { useToast } from "vue-toastification";
const toast = useToast();
import { Bootstrap5Pagination } from 'laravel-vue-pagination'

export default {
    components:{
        Bootstrap5Pagination
    },
    data() {
        return {
            items: [],
            q: this.$route.query,
            form_options: {},
        }
    },
    created() {
        this.getResults();
    },
    methods: {
        getResults ( page = this.$route?.query?.page ?? 1 ) {

            const id = toast.info(this.$t('Getting content ...'),{ icon: 'fa-solid fa-download' });

            axios.get('orders', { params : { 'page' : page, }} ).then(response => {
                toast.dismiss(id);
                this.items = response.data;
            }, response => {
                toast.dismiss(id);
            });
        },
    }
}
</script>
